import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  curTheme: ""
};

const changeThemeSlice = createSlice({
  name: "changeTheme",
  initialState,
  reducers: {
    lightTheme(state) {
      state.curTheme = "PureLightTheme";
    },
    darkTheme(state) {
      state.curTheme = "DarkSpacesTheme";
    },
    setTheme(state, action) {
      state.curTheme = action.payload;
    }
  }
});

export const { lightTheme, darkTheme, setTheme } = changeThemeSlice.actions;

export default changeThemeSlice.reducer;
